import { SelectedItemsManager } from '@/core/support_gui_components/table/table_selected_items_manager'
import { SelectedCellManager } from '@/core/support_gui_components/table/table_selected_cell_manager'
import { SortingManager } from '@/core/support_gui_components/table/table_sorting_manager'
import { FrozenTableElements } from '@/core/support_gui_components/table/table_frozen_elements'
import { booleanStringValueToLogicalBoolean, getLocalizedMessage, saveConfig } from '@/core/shared'
import { routerForInitializeDataIntoFilters } from '@/core/filters/initializeFiltersData'
import { exportLauncher } from '@/core/migration/ExportManager'
import { switchSingleFilterToMultiple } from '@/core/filters/filtersSupport'
import { initRangeDatepicker } from '@/core/input_controls/datepicker/datepicker'
import { dragMaster, DropTarget } from '@/core/support_gui_components/dragAndDrop/dragAndDrop'
import { setAllItemsToolbarMode, setSelectedItemsToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import '@/core/support_gui_components/table/table_pager'
import '@/core/support_gui_components/contextmenu/contextmenu'
import '@/core/plugins/bootstrap-treeview'


export function Table (id, properties, callbacks, dataPreprocessorFunction) {
	'use strict'

	this.id = id
	this.savedState = {}
	this.justStateRestored = false
	this.table = $(properties.selector)
	this.tableColumns = properties.columns || []
	this.externalFilter = properties.externalFilter || false
	this.dynamicLoading = properties.dynamicLoading
	this.itemsPerPage = properties.itemsPerPage || 25
	this.hiddenColumns = properties.hiddenColumns || []
	this.localData = properties.localData || undefined
	this.pager = properties.pager || '#pager'
	this.pageSizer = properties.pageSizer || '#table_toolbar_page-size'
	this.pageSizes = properties.pageSizes || [10, 25, 50, 100, 500]
	this.statusBar = properties.statusBar || '#status-bar'
	this.exportButton = properties.exportButton || false
	this.contextMenu = properties.contextMenu || '#context-menu'
	this.toolbar = properties.toolbar || '.toolbar'
	this.searchPhrase = properties.searchPhrase || '.table_search_phrase'
	this.searchPhraseHtml = undefined
	this.doubleClickMode = properties.doubleClickMode || undefined
	this.dragAndDropSupport = properties.dragAndDropSupport || false
	this.sortingSupport = properties.sortingSupport || false
	this.restoringSupport = properties.restoringSupport || false
	this.cellsSelectionsSupport = properties.cellsSelectionsSupport || false
	this.itemsSelectionsSupport = properties.itemsSelectionsSupport || false
	this.frozen = properties.frozen || true
	this.frozenTableElements = undefined
	this.dataUrl = properties.dataUrl || undefined
	this.dataSortUrl = properties.dataSortUrl || undefined
	this.dataIDsUrl = properties.dataIDsUrl || undefined
	this.filters = properties.filters || {}
	this.saveFiltersSupport = properties.saveFiltersSupport || false
	this.dataPreprocessorFunction = dataPreprocessorFunction
	this.callbacks = callbacks || {}
	this.data = []
	this.itemsIDs = []
	this.currentPage = 1
	this.selectedAttribute = ''
	this.dataIndex = 0
	this.selectedItemsManager = new SelectedItemsManager()
	this.selectedCellManager = new SelectedCellManager(this.table.attr('id'))
	this.sortingManager = new SortingManager()
	this.selectedItemsMode = false
	this.asyncDataLoading = false
	this.isSaveTableState = true
	this.isSaveFilterState = true
	this.isResizableTable = false
	this.filterPreProcessor = properties.filterPreProcessor || function (f) {
		return f
	}

	this.CUSTOM_ATTRIBUTES = ['created', 'status']

	mouseDownAttach(this)
	if (this.sortingSupport) {
		attachSortingControls(this)
	}

	this.getItemsCount = function () {
		return this.dynamicLoading ? _.size(this.itemsIDs) : _.size(this.localData)
	}

	this.generateJsonIDsToDataLoad = function () {
		var startIndex = (this.currentPage - 1) * this.itemsPerPage
		var endIndex = startIndex + this.itemsPerPage > this.getItemsCount() ? this.getItemsCount()
			: startIndex + this.itemsPerPage
		var IDs = []
		for (var i = startIndex; i < endIndex; ++i) {
			IDs.push(this.itemsIDs[i])
		}
		return JSON.stringify(IDs)
	}

	this.setData = function (data) {
		this.localData = data
		if (this.dataPreprocessorFunction) {
			this.dataPreprocessorFunction(this.localData)
		}

		this.dynamicLoading = false
	}

	this.setDataUrl = function (dataUrl) {
		this.dataUrl = dataUrl
		this.dynamicLoading = true
	}

	this.setDataIDsUrl = function (dataIDsUrl) {
		this.dataIDsUrl = dataIDsUrl
	}

	this.setSavedState = function (state) {
		this.savedState.tableState = state
	}

	this.setFiltersDataState = function (filterState) {
		this.savedState.filtersState = filterState
	}

	this.setDataSortUrl = function (dataSortUrl) {
		this.dataSortUrl = dataSortUrl
	}

	this.setFilters = function (filters) {
		this.filters = filters
	}

	this.setColumns = function (columns) {
		this.tableColumns = columns
	}

	this.getPageNumberToStorage = function () {
		return (this.selectedItemsMode && this.selectedItemsManager.getSelectedCount() < this.getItemsCount()) ?
			1 : this.currentPage
	}

	this.loadItemsIDs = function () {
		if (this.dynamicLoading) {
			if (this.selectedItemsMode) {
				this.itemsIDs = this.selectedItemsManager.getSelections()
			} else {
				var preProcessedFilter = this.filterPreProcessor(this.filters)

				$.ajax({
					url: this.dataIDsUrl,
					type: 'POST',
					contentType: 'application/json; charset=utf-8',
					data: JSON.stringify(preProcessedFilter),
					async: false,
					context: this,

					success: function (itemsIDs) {
						this.itemsIDs = itemsIDs
					}
				})
			}
		}
	}

	this.initTable = function (changeMode) {
		var externalFilterMode = false
		if (this.externalFilter != false) {
			externalFilterMode = true
			this.setExternalFilter()
		}

		if (this.restoringSupport && !this.justStateRestored) {
			if (this.checkSavedState() && !changeMode) {
				if (externalFilterMode) {
					if (!this.savedState.tableState) {
						this.savedState.tableState = {}
					}

					this.savedState.tableState['selectedItemsMode'] = false
					this.savedState.tableState['currentPage'] = 1
				}

				this.restoreTableState()

				if (!externalFilterMode) {
					this.restoreFiltersState()
				}

				this.saveTableState()
			}
		}

		if (this.selectedItemsManager.beforeSelectedModeItemsPerPage) {
			this.itemsPerPage = this.selectedItemsManager.beforeSelectedModeItemsPerPage
		}

		this.loadItemsIDs()
		if (this.sortingManager.getAttribute()) this.sortData()
		this.selectedItemsManager.updateIndexesForSelected(this)
		this.createTable()
		this.updateTableElements()
		if (this.frozen != 'none') {
			this.frozenTableElements = new FrozenTableElements(properties['frozenFirstColumn'])
		}
		if (this.sortingSupport) this.sortingManager.makeSortable()
		this.loadData()
		if (externalFilterMode) {
			toggleSearchForm()
		}

		let isFullResizeTable = false

		if (this.isResizableTable) {
			isFullResizeTable = booleanStringValueToLogicalBoolean(sessionStorage.getItem('fullResizeTable'))
		}

		let filter = $('.table_search')

		if (filter.length) {
			if (isFullResizeTable) {
				filter.addClass('collapse')
			} else {
				filter.removeClass('collapse')
			}

			import('@/core/core_components/section/section')
		}
	}

	this.createTable = function () {
		var table = this
		this.searchPhraseHtml = $(this.searchPhrase)
		this.destroyTable()

		this.table.bootstrapTable({
			cache: false,
			striped: true,
			pageSize: this.itemsPerPage,
			showColumns: true,
			undefinedText: '',
			toolbar: table.toolbar,
			searchPhrase: table.searchPhraseHtml,
			isResizableTable: table.isResizableTable,
			columns: this.tableColumns,

			onColumnSwitch: function (field, checked) {
				var position = table.hiddenColumns.indexOf(field)
				if (checked) {
					table.hiddenColumns.splice(position, 1)
				} else {
					table.hiddenColumns.push(field)
				}
				if (table.sortingSupport) {
					table.sortingManager.makeSortable()
					table.sortingManager.stylizeSortControls()
				}
				if (table.frozen != 'none') {
					table.frozenTableElements.initFrozenElements()
				}
				table.selectedCellManager.makeMovable()
				table.selectedCellManager.selectCell()
			},
			onDblClickRow: function (item) {
				if (!_.isEmpty(table.data) && !_.isUndefined(table.doubleClickMode)) {
					if (table.callbacks.doubleClick[table.doubleClickMode]) {
						table.callbacks.doubleClick[table.doubleClickMode](item, table)
					}
				}
			},
			onCheck: function (item) {
				table.selectedItemsManager.addRowMark(table, item.id)
			},
			onUncheck: function (item) {
				table.selectedItemsManager.deleteRowMark(item.id)
			},
			onCheckAll: function () {
				table.selectedItemsManager.addPageMark(table)
			},
			onUncheckAll: function () {
				table.selectedItemsManager.deletePageMark(table)
			},
			formatNoMatches: function () {
				return getLocalizedMessage('nothing.found')
			},
			formatLoadingMessage: function () {
				return '<span class=\'loading fa fa-refresh fa-spin\'></span>'
			},
			onAll: function () {
				table.closeContextMenu()
			}
		})

		$('.fixed-table-pagination').remove()
		this.table.parentsUntil('.bootstrap-table').parent().attr('id', this.table.attr('id') + '_bs-table')
	}

	this.destroyTable = function () {
		this.table.bootstrapTable('destroy')
	}

	this.updateTableElements = function () {
		var elements = []
		if (this.pager) elements.push('pager')
		if (this.pageSizer) elements.push('pageSizer')
		if (this.exportButton) elements.push('exportButton')
		this.createElement(elements)
		this.hideColumns()
	}

	this.createElement = function (element) {
		var objects = [];
		(Array.isArray(element)) ? objects = element : objects.push(element)
		var table = this
		_.each(objects, function (obj) {
			if (!table.isExistElement(obj)) {
				switch (obj) {
				case 'pager': {
					table.createPager()
					break
				}
				case 'contextMenu': {
					table.createContextMenu()
					break
				}
				case 'pageSizer': {
					table.createPageSizer()
					break
				}
				case 'statusBar': {
					table.createStatusBar()
					break
				}
				case 'exportButton': {
					table.destroyExportImportButton()
					table.createExportImportButton()
					break
				}
				}
			}
		})
	}

	this.isExistElement = function (element) {
		var elementID = ''
		switch (element) {
		case 'pager': {
			elementID = this.pager
			break
		}
		case 'contextMenu': {
			elementID = this.contextMenu
			break
		}
		case 'pageSizer': {
			elementID = this.pageSizer
			break
		}
		case 'statusBar': {
			elementID = this.statusBar
			break
		}
		case 'exportButton': {
			elementID = '#table-export'
			break
		}
		}
		return $('.bootstrap-table').find(elementID).length != 0
	}

	this.loadData = function () {
		var elements = []
		if (this.contextMenu) elements.push('contextMenu')
		if (this.statusBar) elements.push('statusBar')

		if (this.dynamicLoading) {
			this.table.bootstrapTable('showLoading')
			var table = this
			table.asyncDataLoading = true
			$.ajax({
				url: this.dataUrl,
				type: 'POST',
				data: { ids: this.generateJsonIDsToDataLoad() },
				context: this,

				success: function (data) {
					this.destroyTooltip()

					table.asyncDataLoading = false
					this.table.bootstrapTable('hideLoading')
					if (this.dataPreprocessorFunction) {
						this.dataPreprocessorFunction(data)
					}
					this.data = data
					this.table.bootstrapTable('load', this.data)
					this.createElement(elements)
					tableDropAttach(this)
					this.selectedItemsManager.updateIndexesForSelected(this)
					this.selectedItemsManager.markRows(this)
					resizeTableHeight()
					this.selectedCellManager.makeMovable()
					this.selectedCellManager.selectCell()
					if (this.frozen != 'none') {
						this.frozenTableElements.initFrozenElements()
						this.frozenTableElements.setFrozenColumnCellsHeight()
					}
					if (this.sortingSupport) {
						this.sortingManager.stylizeSortControls()
					}
				},
				error: function () {
					table.asyncDataLoading = false
				}
			})
		} else {
			this.data = this.localData.slice((this.currentPage - 1) * this.itemsPerPage, (this.currentPage - 1) * this.itemsPerPage + this.itemsPerPage)
			this.table.bootstrapTable('load', this.data)
			this.createElement(elements)
			resizeTableHeight()
			this.selectedCellManager.makeMovable()
			if (this.frozen != 'none') {
				this.frozenTableElements.initFrozenElements()
			}
		}
	}

	this.sortData = function () {
		if (this.dynamicLoading) {
			var table = this
			$.ajax({
				url: this.dataSortUrl,
				type: 'POST',
				data: {
					ids: JSON.stringify(table.itemsIDs),
					attr: table.sortingManager.getAttribute(),
					asc: table.sortingManager.asc
				},
				async: false,
				context: this,

				success: function (itemsIDs) {
					this.itemsIDs = itemsIDs
				}
			})
		}
	}

	this.updateData = function (data, columns) {
		if (columns != undefined) {
			this.setColumns(columns)
		}
		this.setData(data)
		this.justStateRestored = true
		this.initTable()
	}

	this.setExternalFilter = function () {
		var filter = this.filters
		_.each(JSON.parse(this.externalFilter), function (value, attributeName) {
			var attributeType = value.type
			var attributeData = value.data
			var isMultiple = value.multiple
			routerForInitializeDataIntoFilters(attributeType, attributeName, attributeData, isMultiple)

			filter[attributeName] = attributeData
		})

		if (this.externalFilter) {
			history.replaceState({}, '', '/item-table')
		} // remove item status argument to not filter by status after page refresh
		this.externalFilter = false
	}

	this.exportItems = function (configId, all) {
		if (!all) {
			var selectedIDs = this.selectedItemsManager.getSelections()
			if (!_.isEmpty(this.data) && !_.isEmpty(selectedIDs)) {
				exportLauncher.launchExport(selectedIDs, configId, 'table')
			}
		} else {
			if (!_.isEmpty(this.itemsIDs)) {
				exportLauncher.launchExport(this.itemsIDs, configId, 'table')
			}
		}
	}

	this.hideColumns = function () {
		var table = this
		_.each(this.hiddenColumns, function (value) {
			table.table.bootstrapTable('hideColumn', value)
		})
	}

	this.createPager = function () {
		var table = this
		$(this.pager).pagination(this.getItemsCount(), {
			items_per_page: table.itemsPerPage,
			num_display_entries: 5,
			num_edge_entries: 1,
			current_page: table.currentPage - 1,
			callback: function (page) {
				if (table.currentPage != page + 1) {
					table.currentPage = page + 1
					table.closeContextMenu()
					table.loadData()

					window.ClientSessionManager.saveTableState(table)
				}
			}
		})
	}

	this.createPageSizer = function () {
		var table = this
		var all = getLocalizedMessage('all')
		var items = table.itemsPerPage
		var table_footer = $('.page-sizer-container')

		var sizer = '<div id=\'' + this.pageSizer.substr(1, this.pageSizer.length) + '\' class=\'btn-group dropup page-sizer\'>' +
			'<button type=\'button\' class=\'page-sizer_button dropdown-toggle\' data-toggle=\'dropdown\'>' +
			'<span class=\'page-size\'>' + getLocalizedMessage('show.by') + ': ' + items + '</span>' +
			'<span uk-icon="icon: chevron-up; ratio: .8"></span>' +
			'</button>' +
			'<ul class=\'dropdown-menu\' style="right: 0; left: auto;" role=\'menu\'>'
		_.each(this.pageSizes, function (size) {
			sizer += '<li><a>' + size + '</a></li>'
		})
		sizer += '</ul></div>'
		table_footer.empty().append(sizer)

		var pageSizer = this.pageSizer + ' '
		$(pageSizer + 'ul').find('li').removeClass('active')

		$(pageSizer + 'ul li').find('a').each(function () {
			if (parseInt($(this)[0].innerHTML) == table.itemsPerPage) {
				$(this).closest('li').addClass('active')
			}
		})

		function resizePage (table, size) {
			table.itemsPerPage = size
			table.currentPage = 1
			table.createTable()
			table.updateTableElements()
			if (table.sortingSupport) table.sortingManager.makeSortable()
			table.loadData()

			window.ClientSessionManager.saveTableState(table)
		}

		$(pageSizer + 'ul li a').bind('click', function () {
			var size = parseInt(this.innerHTML, 10)
			size = (!_.isNaN(size)) ? size : table.getItemsCount()
			resizePage(table, size)
		})
	}

	this.createExportImportButton = function () {
		var table = this
		$('.fixed-table-toolbar .bars .toolbar').append('' +
			'<button id=\'table-import\' title=\'' + getLocalizedMessage('import') + '\'>' +
			'<span uk-icon="download"></span>' +
			'<span class=\'title\'>' + getLocalizedMessage('import') + '</span>' +
			'</button>' +
			'<button id=\'table-export\' title=\'' + getLocalizedMessage('export') + '\'>' +
			'<span uk-icon="upload"></span>' +
			'<span class=\'title\'>' + getLocalizedMessage('export') + '</span>' +
			'</button>'
		)

		$('#table-export').bind('click', function () {
			$('#export-form').modal()
		})
		$('#table-import').bind('click', function () {
			document.location.href = '/import-history'
		})

		var onNodeExpandOrCollapse = function (event, node) {
			var expanded = node.state.expanded
			var id = node.id
			if (id === undefined) {
				return
			}

			$('#export-templates-list > div.tab-pane').each(function () {
				var treeView = $(this).eq(0).find('.treeview').data('treeview')
				var currentNode = treeView.findNodeByPredicate(function (v) {
					return v.id === id
				})

				if (currentNode === undefined) {
					return
				}

				if (expanded) {
					treeView.expandNode(currentNode, { silent: true })
				} else {
					treeView.collapseNode(currentNode, { silent: true })
				}
			})

			$.ajax({
				url: window.urlContext + 'user-tags/' + id,
				type: 'POST',
				contentType: 'application/json; charset=UTF-8',
				async: true
			})
		}

		$('#export-templates-list').on('nodeExpanded', onNodeExpandOrCollapse)
		$('#export-templates-list').on('nodeCollapsed', onNodeExpandOrCollapse)

		var onNodeClick = function (event, data) {
			var exportLink = $($.parseHTML(data.text))
			var exportConfigId = exportLink.attr('data-config-id')
			if (exportConfigId !== undefined) {
				$('#export-form').modal('hide');

				($('#export-form .export-variant input[type=radio]:checked').attr('data-type') == 'all') ? table.exportItems(exportConfigId,
					true) : table.exportItems(exportConfigId)
			}
		}

		$('#export-templates-list').on('nodeSelected', onNodeClick)
		$('#export-templates-list').on('nodeUnselected', onNodeClick)
	}

	this.createStatusBar = function () {
		let beginItem = 0, endItem = 0
		if (this.getItemsCount() > 0) {
			beginItem = (this.currentPage == 1) ? 0 : (this.currentPage - 1) * this.itemsPerPage
			endItem = (beginItem + this.itemsPerPage <= this.getItemsCount()) ? beginItem + this.itemsPerPage : this.getItemsCount()
		} else {
			beginItem = -1
		}

		let statusBar = $(this.statusBar)[0]

		if (statusBar) {
			statusBar.innerHTML = '<span class=\'show-records\'>' + getLocalizedMessage('shown.records') + ':</span> ' + (beginItem + 1) + ' — ' + endItem + ' ' + getLocalizedMessage('of') + ' ' + this.getItemsCount()
		}

	}

	this.setContextMenuCallbackObject = function (obj) {
		this.callbacks['contextMenu'] = obj
	}

	this.createContextMenu = function () {
		if (!_.isEmpty(this.data)) {
			this.table.find('tbody').attr('id', this.contextMenu.substr(1, this.pageSizer.length) + '_context').attr('data-toggle', 'context').attr('data-target', this.contextMenu)
			var selectedRow = ''
			var table = this

			if (table.callbacks.contextMenu) {
				var contexMenuList = $(this.contextMenu + ' ul').children()
				$(this.contextMenu + '_context').contextmenu({
					target: table.contextMenu,
					onItem: function (context, e) {
						if (table.callbacks.contextMenu) {
							if (selectedRow != -1) {
								_.each(table.callbacks.contextMenu, function (func, item) {
									if (contexMenuList.eq(item - 1)[0] == $(e.target).parent()[0]) {
										table.callbacks.contextMenu[item](table.data[selectedRow], table.selectedAttribute)
									}
								})
							}
						}
					}
				})
			}

			$(this.contextMenu).on('show.bs.context', function (e) {
				var row = parseInt($(e.target).closest('tr').attr('data-index'))
				if (!_.isEmpty(row)) {
					selectedRow = row
				} else if (!_.isEmpty(table.data)) {
					selectedRow = row
				} else {
					selectedRow = -1
				}
			})
		}
	}

	this.checkSavedState = function () {
		if (!_.isEmpty(this.savedState)) {
			return true
		} else {
			return false
		}
	}

	this._saveLocalStorageStateTable = function (key, state) {
		var config = JSON.parse(localStorage.getItem(this.id))
		if (config) {
			config[key] = state
			localStorage.setItem(this.id, JSON.stringify(config))
		}
	}

	this.saveFiltersState = function () {
		if (this.filters !== undefined && this.isSaveFilterState) {
			saveConfig(this.id + '.filtersState', JSON.stringify(this.filters))
		}
	}

	this.saveTableState = function () {
		if (!this.isSaveTableState) {
			return
		}

		var tableState = {}
		if ($('.toolbar').find('.active-manager') != undefined) {
			tableState['activeColumnSet'] = $('.toolbar').find('.active-manager').attr('id')
		}
		tableState['itemsPerPage'] = this.itemsPerPage
		tableState['currentPage'] = this.getPageNumberToStorage()
		tableState['hiddenColumns'] = this.hiddenColumns
		if (this.itemsSelectionsSupport) {
			tableState['selectionsConfig'] = this.selectedItemsManager.getSelectionsConfig()
			tableState['selectedItemsMode'] = this.selectedItemsMode
		}
		if (this.cellsSelectionsSupport && this.selectedCellManager.needSave()) {
			tableState['cellSelectionsConfig'] = this.selectedCellManager.getSelectionsConfig()
		}
		if (this.sortingSupport) {
			tableState['sortingConfig'] = this.sortingManager.getSortingConfig()
		}
		saveConfig(this.id + '.tableState', JSON.stringify(tableState))
		this._saveLocalStorageStateTable('tableState', tableState)

		if (this.saveFiltersSupport) {
			this.saveFiltersState()
		}
	}

	this.restoreFiltersState = function () {
		if (!_.isEmpty(this.savedState.filtersState)) {
			if (!this.selectedItemsMode) {
				toggleSearchForm('restoring')
			}
			_.each(this.savedState.filtersState, function (attribute, attributeName) {
				var isMultiple = false
				if (_.isArray(attribute.val) && !$('#' + attributeName).find('textarea').is('textarea')) {
					switchSingleFilterToMultiple('#' + attributeName + ' .button_multiple-switcher')
					isMultiple = true
				}
				var attributeType = (attribute['type']) ? attribute['type'] : 'status'
				routerForInitializeDataIntoFilters(attributeType, attributeName, attribute, isMultiple)
			})
			this.setFilters(this.savedState.filtersState)
		} else {
			if (!this.selectedItemsMode) {
				toggleSearchForm()
			}
		}
	}

	this.restoreTableState = function () {
		if (!_.isEmpty(this.savedState.tableState)) {
			if (this.savedState.tableState['itemsPerPage']) {
				this.itemsPerPage = this.savedState.tableState['itemsPerPage']
			}

			if (this.savedState.tableState['activeColumnSet']) {
				var activeId = this.savedState.tableState['activeColumnSet']
				$('#' + activeId).click()
			}

			if (this.savedState.tableState['currentPage']) {
				this.currentPage = this.savedState.tableState['currentPage']
			}

			if (this.savedState.tableState['hiddenColumns']) {
				var context = this
				_.each(this.savedState.tableState['hiddenColumns'], function (hiddenColIndex) {
					_.each(context.tableColumns, function (col, tableColIndex) {
						if (tableColIndex === hiddenColIndex) {
							context.hiddenColumns.push(hiddenColIndex)
						}
					})
				})
			}

			if (this.itemsSelectionsSupport && this.savedState.tableState['selectionsConfig']) {
				this.selectedItemsManager.setSelectionsConfig(this.savedState.tableState['selectionsConfig'])
			}

			if (this.cellsSelectionsSupport && this.savedState.tableState['cellSelectionsConfig']) {
				this.selectedCellManager.setSelectionsConfig(this.savedState.tableState['cellSelectionsConfig'])
			}

			if (this.itemsSelectionsSupport && this.savedState.tableState['selectedItemsMode']) {
				this.selectedItemsMode = this.savedState.tableState['selectedItemsMode']
			}

			if (this.savedState.tableState['sortingConfig']) {
				this.sortingManager.setSortingConfig(this.savedState.tableState['sortingConfig'])
			}
		}

		this.justStateRestored = true
	}

	this.destroyExportImportButton = function () {
		$('#table-export').unbind('click')
		$('#table-import').unbind('click')
		$('#table-export').remove()
		$('#table-import').remove()
	}

	this.destroyTooltip =function () {
		$('.tooltip').tooltip('destroy')
	}

	this.closeContextMenu = function () {
		if (this.contextMenu) {
			$(this.contextMenu).removeClass('open')
		}
	}

	this.destroyContextMenu = function () {
		if (this.contextMenu) {
			$(this.contextMenu + '_context').off('contextmenu')
		}
	}

	function mouseDownAttach (table) {
		table.table.on('mousedown', 'td', function (e) {
			var attributeWithIndex = this.className.split(' ')[0]
			table.selectedAttribute = attributeWithIndex.split('__')[0]
			if (_.isEmpty(table.data)) return
			if (e.button == 0 || e.button == 2) {
				if (table.dragAndDropSupport && e.button == 0 && e.shiftKey) {
					tableRowDragAttach(e)
				}
				if (!e.target.classList.contains('bs-checkbox') &&
					!e.target.parentNode.classList.contains('bs-checkbox')) {
					table.selectedCellManager.setSelectedCell($(e.target).parent())
				}
				table.dataIndex = parseInt($(e.target).closest('tr').attr('data-index'))
			}
		})
	}
}

export function addItem () {
	location.href = '/item-create'
}

export function toggleSearchForm (state) {
	// var tableSearch = '.table_search'
	// $(tableSearch).toggleClass('form-open')
	initRangeDatepicker()
	if (state != 'restoring') {
		resizeTableHeight()
	}
}

function tableDropAttach (table) {
	if (_.isEmpty(table.data) || !table.dragAndDropSupport) {
		return false
	}
	$('#table tbody tr').each(
		function (ind, element) {
			$(element).data('data', table.data[ind].id)
			new DropTarget(element, 'table-row-drop-target', onTableRowAccept)
		}
	)
}

function tableRowDragAttach (e) {
	var row = $(e.target).closest('tr')
	dragMaster.makeDraggableRow(row, 'table-row-drag', null, e)
}

function onTableRowAccept (dragRow, targetRow) {
	var sourceId = $(dragRow).data('data')
	var targetId = $(targetRow).data('data')
	if (sourceId != targetId) {
		location.href = 'item-edit/' + targetId + '?sourceItemId=' + sourceId
	}
}

export function tableShowAllItems (e, itemTable) {
	var table = itemTable ? itemTable : e.data.itemTable
	if (table.asyncDataLoading) {
		return
	}
	setAllItemsToolbarMode()
	// if (!_.isEmpty(table.filters))
	if (!$('.uk-breadcrumb').hasClass('uk-hidden')) {
		toggleSearchForm()
	}
	table.selectedItemsMode = false
	table.currentPage = table.selectedItemsManager.beforeSelectedModePage

	table.sortingManager.setSortingConfig({
		attr: table.selectedItemsManager.beforeSelectedModeSortAttr,
		asc: table.selectedItemsManager.beforeSelectedModeSortAsc
	})

	table.initTable(true)
	table.selectedItemsManager.beforeSelectedModePage = 0
	table.selectedItemsManager.beforeSelectedModeItemsPerPage = 0
	table.sortingManager.setSortingConfig({
		attr: table.selectedItemsManager.beforeSelectedModeSortAttr,
		asc: table.selectedItemsManager.beforeSelectedModeSortAsc
	})
}

export function tableShowSelectedItems (e) {
	var table = e.data.itemTable
	if (table.asyncDataLoading) {
		return
	}
	setSelectedItemsToolbarMode()
	// if ($(".table_search").hasClass("form-open"))
	/*if (!$('.uk-breadcrumb').hasClass('uk-hidden'))
		toggleSearchForm();*/
	table.selectedItemsMode = true
	table.selectedItemsManager.beforeSelectedModePage = table.currentPage
	table.selectedItemsManager.beforeSelectedModeItemsPerPage = table.itemsPerPage
	var sortParams = table.sortingManager.getSortingConfig()
	table.selectedItemsManager.beforeSelectedModeSortAsc = sortParams.asc
	table.selectedItemsManager.beforeSelectedModeSortAttr = sortParams.attr
	table.currentPage = 1
	table.initTable(true)
}

export function tableClearSelectedItems (e) {
	e.data.itemTable.selectedItemsManager.clearSelections(e.data.itemTable)
}

export function resizeTableHeight () {
	// $('.table-area-row').css('height', 'calc(100% - ' + getElementsHeight(['header', '.table-footer', '.uk-breadcrumb', '.table_search']) + 'px)');
	var container = $('.fixed-table-container')
	var scrollHeight = 18
	var column = $('#table-frozen-column')
	column.css('height', (container.height() - scrollHeight) + 'px')
	if (container.offset()) column.css('top', '0px')
	if (window.browser == 'firefox') {
		column.children('th').first().css('top', '0px')
	}

	if (container.offset()) $('#table-frozen-header').css('top', '0px')

	function getElementsHeight (elements) {
		var height = 0
		_.each(elements, function (element) {
			if ($(element).innerHeight()) {
				height += $(element).innerHeight()
			}
		})
		return height
	}
}

function attachSortingControls (table) {
	$('#table').on('click', '.table_sort_asc', {
		itemTable: table,
		asc: true
	}, tableDataSorting)
	$('#table').on('click', '.table_sort_desc', {
		itemTable: table,
		asc: false
	}, tableDataSorting)
}

function tableDataSorting (e) {
	var table = e.data.itemTable
	var asc = e.data.asc
	var th = $(e.target).closest('th')
	var attribute = th.attr('class').split(' ')[0]
	if (table.asyncDataLoading || !table.sortingSupport ||
		!table.sortingManager.checkToNeedSorting(attribute, asc)) {
		return
	}
	table.sortingManager.setSortingConfig({
		attr: attribute,
		asc: asc
	})
	table.sortingManager.stylizeSortControls()
	table.sortData()
	table.selectedItemsManager.updateIndexesForSelected(table)
	table.loadData(false)

	window.ClientSessionManager.saveTableState(table)
}
